import { memo } from 'react';

import Lottie from 'lottie-react';

import { OButton, OCheck, OModal } from '@src/shared';

import useInfoModal from './useInfoModal';

import LoadingDotsDark from '@src/assets/animations/LoadingDotsDark.json';
import LoadingDotsLight from '@src/assets/animations/LoadingDotsLight.json';

import './infoModal.scss';

const InfoModal = () => {
  const {
    size = 'small',
    icon,
    title,
    footer,
    buttons,
    checkbox,
    description,
    theme,
    isMobile,
    isInfoModalOpen,
    handleModalButtonClick,
    handleOnCloseModal,
  } = useInfoModal();

  const buttonSize = isMobile ? 'medium' : size === 'medium' ? 'm-small' : 'large';

  return (
    <OModal
      isOpen={isInfoModalOpen}
      classes={{
        container: `info-modal-container modal-${size}`,
        body: 'info-modal-body',
        header: 'info-modal-header',
        closeIcon: 'close-icon-style',
        closeIconWrapper: 'info-close-wrapper',
      }}
      onClose={handleOnCloseModal}
      hasBackdrop
    >
      {icon &&
        (typeof icon === 'string' ? (
          <img src={icon} alt="img" className="info-modal-img" />
        ) : (
          <div className="info-modal-icon">{icon}</div>
        ))}

      <div className="info-modal-content">
        <p className="info-modal-title" id="modal-title">
          {title}
        </p>
        {description && (
          <p className="info-modal-description" id="modal-description">
            {description}
          </p>
        )}
        {checkbox && (
          <div className="info-modal-checkbox">
            <OCheck checked={checkbox.checked} onChange={() => checkbox.onChange(!checkbox.checked)} />
            <span>{checkbox.label}</span>
          </div>
        )}
        {footer && (
          <div className="footer-wrapper" id="modal-footer">
            <span className="footer-text">{footer.text}</span>
            {footer.isLoading && (
              <Lottie
                animationData={theme === 'light' ? LoadingDotsLight : LoadingDotsDark}
                loop
                style={{ width: 24, height: 18 }}
              />
            )}
          </div>
        )}
        {buttons?.length && (
          <div className={`info-modal-buttons ${buttons.length === 2 ? 'has-two-buttons' : ''}`}>
            {buttons?.map((btn, index) => (
              <OButton
                id="modal-button"
                key={`${btn.text}-${index}`}
                variant={btn.variant}
                isDisabled={btn.disabled}
                size={buttonSize}
                onClick={(e) =>
                  handleModalButtonClick(() => {
                    if (btn.onClick) {
                      btn.onClick(e);
                    }
                  })
                }
                classes={{
                  container: 'info-modal-button',
                }}
                {...btn}
              />
            ))}
          </div>
        )}
      </div>
    </OModal>
  );
};

export default memo(InfoModal);
